// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: white;
}

.reports-container {
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding:2%;
    padding-left:4%; 
    padding-right: 4%; 

    background-color: white;
  
}

.direct-button {
    margin: 10px 15px;
    padding: 1px;
    color: rgb(255, 255, 255);
    background-color: #286090;
    border-radius: 5px;
    width: max-content;
    font-size: 15px;
    text-align: left;
} 

.report-deligation-container{
    width:100%;
   
 }

 .report-deligation-sub-container{
    width:100%;
    border:2px solid  #286090;
    border-radius:10px;
    margin:2% 0%;
 }
 .container1{
   
    margin: 0px;
   padding-left: 2%;
   padding-right: 2%;
    border-radius: 10px;
    background-color: #fff;
 }

 /* .pending-deligations{
    text-align:center;
 } */

 .employee-detail-container{
    width:100%;
    border:2px solid  #286090;
    border-radius:10PX;
 }
 .text
{
    text-align: left;
    font-weight: bold;
    padding-left: 1%;
}
.select-text
{
    color:white;
    background-color: #286090;
    border-radius: 5px 5px 0 0;
    text-align: left;
    padding-left:1%;
}

.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10px;
  }
  /* .searchFilter{
    display: grid;
    padding-bottom: 10px;
  }
  
  .center-content {
    margin: auto !important;
    text-align: center;
  } */
  
 
.employee-name-text{
  margin-left:1%;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px; /* Adjust as needed */
}



  

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/report/directdelegationadmin/directdelegationadmin.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,iBAAiB;;IAEjB,uBAAuB;;AAE3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;;CAEb;;CAEA;IACG,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;CACf;CACA;;IAEG,WAAW;GACZ,gBAAgB;GAChB,iBAAiB;IAChB,mBAAmB;IACnB,sBAAsB;CACzB;;CAEA;;IAEG;;CAEH;IACG,UAAU;IACV,yBAAyB;IACzB,kBAAkB;CACrB;CACA;;IAEG,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;EACA;;;;;;;;KAQG;;;AAGL;EACE,cAAc;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;AAC3C;;;;;;AAMA,g6GAAg6G","sourcesContent":["body {\n    background-color: white;\n}\n\n.reports-container {\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding:2%;\n    padding-left:4%; \n    padding-right: 4%; \n\n    background-color: white;\n  \n}\n\n.direct-button {\n    margin: 10px 15px;\n    padding: 1px;\n    color: rgb(255, 255, 255);\n    background-color: #286090;\n    border-radius: 5px;\n    width: max-content;\n    font-size: 15px;\n    text-align: left;\n} \n\n.report-deligation-container{\n    width:100%;\n   \n }\n\n .report-deligation-sub-container{\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10px;\n    margin:2% 0%;\n }\n .container1{\n   \n    margin: 0px;\n   padding-left: 2%;\n   padding-right: 2%;\n    border-radius: 10px;\n    background-color: #fff;\n }\n\n /* .pending-deligations{\n    text-align:center;\n } */\n\n .employee-detail-container{\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10PX;\n }\n .text\n{\n    text-align: left;\n    font-weight: bold;\n    padding-left: 1%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    border-radius: 5px 5px 0 0;\n    text-align: left;\n    padding-left:1%;\n}\n\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 10px;\n  }\n  /* .searchFilter{\n    display: grid;\n    padding-bottom: 10px;\n  }\n  \n  .center-content {\n    margin: auto !important;\n    text-align: center;\n  } */\n  \n \n.employee-name-text{\n  margin-left:1%;\n}\n\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px; /* Adjust as needed */\n}\n\n\n\n  \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
